// extracted by mini-css-extract-plugin
module.exports = {"main":"Ywf-PdZI","explain":"_1oIJbGKz"};